module.exports = __webpack_public_path__ + "img/single-site-screen.8517ad55.svg";